import { Parser } from 'im.v2.lib.parser';
import { PrigovCode } from './code-highlighter';

if (!window.__prigovImCodeHighlightInited)
{
  window.__prigovImCodeHighlightInited = true;

  const originalDecode = Parser.decode.bind(Parser);

  Parser.decode = function(config)
  {
    if (config && typeof config === 'object' && typeof config.text === 'string')
    {
      config = { ...config, text: PrigovCode.preprocessText(config.text) };
    }

    const html = originalDecode(config);

    queueMicrotask(() => PrigovCode.highlightAllInDocument());
    return html;
  };

  PrigovCode.init();
}
